<template>
    <div>
        <div class="cg" v-for="(item,index) in data.rows" style="height: 3%">
            <div style="display: inline-block;width: 100%">
                  <el-link :underline="false" style="font-size:14px;font-family:Microsoft YaHei;font-weight:normal;color:#171616;line-height:30px;">
                    <span v-html="item.subject" class="subject-title" @click="showDetail(item.id)"></span>
                    <p class="subject-item">{{ item.creator }} | {{ item.createTime }}</p>
                </el-link>
            </div>
            <!-- <div style="margin-top:2px;height:1px;background:rgba(235,238,245,1);"></div> -->
        </div>
    </div>
</template>
<script>
import req from "@/request.js";

export default {
  props: {
    data: {
      default: {}
    }
  },
  data() {
    return {
     
    };
  },
  components: {

  },
  created() {
    
  },
  methods: {
    checkTheInstance:function(row){
      this.$router.push('/inst/'+row.id) ;
    },
    showDetail(id){
        window.open(window.context.front +'/inst/'+id+'/read');
    }
  }
};
</script>
<style lang="stylus" scoped>
    .el-table__row >>> .el-tooltip{
        width:90%
    }
    .subject-item >>> p{
        margin-top:0px;
    }

  .subject-item {
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9D9FAD;
    line-height: 22px;
  }
  .subject-title{
    padding-bottom: 4px;
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #292B44;
    line-height: 22px;

    /*文字超出省略*/
    display: -webkit-box;
    display: -moz-box;
    white-space: pre-wrap;
    word-break:break-all;
    word-wrap:break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:1;   /*显示行数*/
  }
  .cg{
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 0px;
    padding-right: 0px;
    &:hover{
      background:#EDF6FB;
      .subject-item{
        color: #1890FF !important;
      }
      .subject-title{
        color: #1890FF !important;
      }
    }
}
  /deep/ .el-link--inner{/*处理缩略后的换行符*/

    height: 48px;
    margin-left: 24px; 
    br{
      display: none;
    }
  }
</style>